export enum TriggerSource {
    Manual = 'manual',
    Schedule = 'schedule',
    Trigger = 'trigger',
    Api = 'api',
}
